import React from 'react';
import { Tag } from '@oneaudi/unified-web-components';
import type { IconNamesType } from '@oneaudi/unified-web-components/dist/cjs/components/icon/icon-names.generated';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import trackingContext from '../../../contexts/tracking-context';
import { trackAddFilterAction, trackRemoveFilterAction } from '../../../utils/trackingUtils';
import { useURLService } from '../../../hooks/useURLService';

export type Props = {
  filterKey: string;
  label: string;
  isSelected: boolean;
  readOnly?: boolean;
};

export const FilterItem = ({ filterKey, label, isSelected, readOnly = false }: Props) => {
  const dispatch = mapContext.useMapDispatch();
  const { userSelectedFilters, searchText } = mapContext.useMapState();
  const { trackingService: tService } = trackingContext.useTrackingState();
  const generateURL = useURLService();

  function toggleFilter() {
    const currentUrl = window.location.href;
    const payload = {
      query: searchText,
      filters: [...userSelectedFilters, filterKey],
    };
    const url = generateURL(currentUrl, payload);
    dispatch({ type: ActionTypes.setUpdateMapZoomLevel, payload: false });
    if (isSelected) {
      dispatch({ type: ActionTypes.removeFilter, payload: filterKey });
      trackRemoveFilterAction(tService, label, filterKey, 'FilterItem', url.href);
    } else {
      dispatch({ type: ActionTypes.addFilter, payload: filterKey });
      trackAddFilterAction(tService, label, filterKey, 'FilterItem', url.href);
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (readOnly) return;

    if (event.key === 'Enter') {
      event.preventDefault();
      toggleFilter();
    }
  };

  const icons: Record<string, IconNamesType> = {
    sales: 'shopping-basket',
    service: 'maintenance',
    usedcars: 'used-cars',
    etron: 'car',
    'sales-rs': 'top-speed',
    'sales-r8': 'top-speed',
    'service-r8': 'top-speed',
    'audi-on-demand': 'poi-car',
    //** Commenting centrum-flotowe since is not ready for production
    // 'centrum-flotowe': 'traffic',
    'accident-specialist': 'caution',
    atyourdoor: 'car-handover',
    'silver-car-by-audi': 'car',
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div onKeyDown={handleKeyDown}>
      <Tag
        id={filterKey}
        checked={isSelected}
        disabled={readOnly}
        onChange={toggleFilter}
        data-test-id="filter-item-component"
        label={label}
        value=""
        name="tag"
        variant="selectable"
        icon={icons[filterKey]}
      />
    </div>
  );
};
